import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { take } from "rxjs/operators";
import { DestroyBase } from "../ng-destroy-base";
import { AppServiceHelperService } from "../../../services/app-service-helper.service";

/**
 * Handles connecting currencies to valuation event
 */
@Component({
  selector: 'report-argus-sync-dialog',
  templateUrl: './report-argus-sync-dialog.component.html',
  styleUrls: ['./report-argus-sync-dialog.component.css']
})
export class ReportArgusSyncDialogComponent extends DestroyBase implements OnInit, OnDestroy {
  /**
   * Is the import a success or failure?
   */
  public isSuccessOrFailure = false;

  /**
   * Config sets to any
   */
  public config: any[] = [];

  /**
   * Report Ids to sync
   */
  @Input() public reportIds: number[];

  /**
 * Should the pane be closed?
 */
  shouldClose = false;

  /**
 * Can be closed? (as Infobar in table view)
 */
  @Input() public canClose: boolean;

  /**
 * Close pane event
 */
  @Output() public closePane: EventEmitter<any> = new EventEmitter();

  /**
   * Constructor
   * @param _ais
   * @param http
   */
  constructor(private http: HttpClient, private appServiceHelper: AppServiceHelperService) {
    super();
  }
  /**
   * OnInit
   */
  ngOnInit(): void {
    for (const reportId of this.reportIds) {
      ((self, reportIdLocal) => {
        const url = `import/v2/argus?reportId=${reportIdLocal}`;
        this.http.post(this.appServiceHelper.getServiceEndpoint('pollux.import.api', url), {})
          .pipe(take(1)).subscribe((result: any) => {
            const config = {
              reportId: reportId,
              importGuid: result,
              messages: [],
              isSuccessOrFailure: false,
              timeout: null
            };
            self.config.push(config);
            self.getMessages(config);
          });
      })(this, reportId);//IIFE to copy the report ID and keep it
    }
  }

  /**
   * OnDestroy
   */
  ngOnDestroy(): void {
    super.ngOnDestroy();
    for (const config of this.config) {
      this.stopTimer(config);
    }
  }
  /**
   * Stops the timer for the given config
   */
  private stopTimer(config: any): void {
    if (config.timeout !== null) {
      clearTimeout(config.timeout);
      config.timeout = null;
    }
  }
  /**
   * Gets the messages for the given config
   */
  private getMessages(config: any) {
    const url = `import/v2/messages?importGuid=${config.importGuid}`;
    this.http.get(this.appServiceHelper.getServiceEndpoint('pollux.import.api', url))
      .pipe(take(1)).subscribe((result: any[]) => {
        if (!this.shouldClose) {
          config.messages = result;

          config.isSuccessOrFailure = result.some((message) => message.level === 'SUCCESS' || message.level === 'ERROR');

          if (!config.isSuccessOrFailure) {
            config.timeout = setTimeout(() => this.getMessages(config), 5000);
          } else {
            this.stopTimer(config);
          }

          let allCompleted = true;
          for (const conf of this.config) {
            if (!conf.messages.some((message) => message.level === 'SUCCESS' || message.level === 'ERROR')) {
              allCompleted = false;
              break;
            }
          }
          this.isSuccessOrFailure = allCompleted;
        }
      });
  }

  /**
   * If close button is clicked it will close the pane
   */
  public closeClicked(): void {
    this.shouldClose = true;
    for (const config of this.config) {
      this.stopTimer(config);
    }
    setTimeout(() => {
      this.closePane.emit();
    }, 500);
  }
}
